import { Empty, Icon } from 'ui';
import { useDebounce } from 'common/hooks';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EntityList } from 'features/channels/components';
import { useOrganizationsInfiniteQuery } from '../../../queries';

type P = {
  getPathToOrganizationDetail: (id: string) => string;
  search?: string;
};

const JoinedOrganizationsListContent = ({ getPathToOrganizationDetail, search: propertySearch }: P) => {
  const { isDebouncing, value } = useDebounce(propertySearch);
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading } = useOrganizationsInfiniteQuery({
    filter: { scope: 'joined', search: value },
    pagination: { pageSize: 12 },
  });

  const organizations = data?.pages.flatMap((organizationsPaginated) => organizationsPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no organizations to display here',
            title: 'No organizations',
          }}
          image={<Icon icon="bank-line" />}
        />
      }
      entities={organizations?.map((organization) => ({
        data: organization,
        type: 'Organization',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToOrganizationDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetching}
      isLoading={isDebouncing || isLoading}
    />
  );
};

export default JoinedOrganizationsListContent;
